export const generateOriginDestinationKey = (origin, destination)=>`${origin?.id}-${destination?.id}`;

//# sourceMappingURL=keys.js.map